import r from "../managers/braze-instance.js";
import i from "./banner-provider-factory.js";
import { getAllBanners } from "./get-all-banners.js";
export function subscribeToBannersUpdates(n) {
  var o;
  if (!r.rr()) return;
  var t = i.o();
  if (t.Ct()) {
    var _r = getAllBanners();
    _r && "function" == typeof n && n(_r);
  }
  var s = t.St(n);
  if (!t.jt()) {
    var _n = null === (o = r.nn()) || void 0 === o ? void 0 : o.rn(function () {
      var n = t.et();
      n && n.length > 0 && t.M(n);
    });
    _n && t.yt(_n);
  }
  return s;
}